import { useEffect, useState } from "react";
import ColorfulLoading from "../../images/ColorfulLoading";
import "./ClickEffects.css";
import ClickArcs from "../../images/ClickArcs";
import MouseLine from "../../images/MouseLine";
import ClickTriangles from "../../images/ClickTriangles";

interface Point {
	x: number;
	y: number;
}

interface Click extends Point {
	id: number;
}

const ClickEffects = () => {
	const [clicks, setClicks] = useState<Click[]>([]);
	const [moves, setMoves] = useState<Click[]>([]);
	const [down, setDown] = useState(false);

	useEffect(() => {
		const onClick = (event: MouseEvent) => {
			setClicks(x => {
				const y: Click[] = [{ id: new Date().getTime(), x: event.pageX, y: event.pageY }];
				x.forEach((c, i) => {
					if (i < 4) {
						y.push(c);
					}
				});
				return y;
			})
		}
		document.addEventListener("mousedown", onClick);
		return () => {
			document.removeEventListener("mousedown", onClick);
		}
	}, []);

	useEffect(() => {
		const onDown = (event: MouseEvent) => {
			if (event.buttons !== 1) { return; }
			setDown(true);
		}
		const onUp = (event: MouseEvent) => {
			setDown(false);
		}
		document.addEventListener("mousedown", onDown);
		document.addEventListener("mouseup", onUp);
		return () => {
			document.removeEventListener("mousedown", onDown);
			document.removeEventListener("mouseup", onUp);
		}
	}, []);

	useEffect(() => {
		const onDown = (event: TouchEvent) => {
			setDown(true);
		}
		const onUp = (event: TouchEvent) => {
			setDown(false);
		}
		document.addEventListener("touchstart", onDown);
		document.addEventListener("touchend", onUp);
		return () => {
			document.removeEventListener("touchstart", onDown);
			document.removeEventListener("touchend", onUp);
		}
	}, []);

	useEffect(() => {
		const onMove = (point: Point) => {
			if (!down) {
				return; 
			}
			setMoves(x => {
				const date = new Date().getTime();
				const y: Click = { id: new Date().getTime(), ...point };
				if (!x.length) {
					return [y];
				}
				if (x[0].id > y.id - 20) {
					return x.filter(c => c.id > date - 1000);
				}
				return [y, ...x.filter(c => c.id > date - 1000)];
			})
		}
		const onMouseMove = (event: MouseEvent) => {
			onMove({ x: event.pageX, y: event.pageY });
		}
		const onTouchMove = (event: TouchEvent) => {
			onMove({ x: event.touches[0].pageX, y: event.touches[0].pageY });
		}
		document.addEventListener("mousemove", onMouseMove);
		document.addEventListener("touchmove", onTouchMove);
		return () => {
			document.removeEventListener("mousemove", onMouseMove);
			document.removeEventListener("touchmove", onTouchMove);
		}
	}, [down]);

	const date = new Date().getTime();
	// console.log(clicks[0]);

	return <div className="clickEffectsContainer">
		{clicks.filter(c => c.id > date - 5000).map(c => {
			return <div key={c.id} className="clickEffect"
				style={{ left: `${c.x}px`, top: `${c.y}px` }}>
				<ClickArcs width="100%" height="100%" />
			</div>
		})}
		<div className="dragEffect" style={{ height: Math.max(...moves.map(m => m.y)) + "px" }}>
			<MouseLine points={moves} />
		</div>
		{moves.filter(c => c.id > date - 500).map(c => {
			return <div key={c.id} className="clickEffectTriangles"
				style={{ left: `${c.x}px`, top: `${c.y}px` }}>
				<ClickTriangles />
			</div>
		})}
	</div>;
}

// const ClickEffect = (props: Click) => {
// 	const { id, x, y } = props;
// 	const [fade, setFade] = useState(false);

// 	useEffect(() => {
// 		setTimeout(() => { setFade(true)})
// 	}, [])

// 	return <div className="clickEffect fadeClick"
// 		style={{ left: `${x}px`, top: `${y}px` }}>
// 		<ColorfulLoading width="100%" height="100%" />
// 	</div>;
// }

export default ClickEffects;